const ACTIVE_REQUEST_STATUSES = new Set([
  "Pending HC",
  "Pending CCD",
  "Approved - Ready for Graph Update",
  "Updating Microsoft 365",
]);

export function isActiveEmployeeRequest(submission) {
  if (!submission) return false;
  return Boolean(submission.canCancel) || ACTIVE_REQUEST_STATUSES.has(submission.status);
}

export function photoRemovalAvailability(submission) {
  const active = isActiveEmployeeRequest(submission);
  return {
    disabled: active,
    reason: active
      ? `You already have an active request (${submission.status}). Cancel or complete it before requesting photo removal.`
      : "",
  };
}
